import { createFileRoute } from '@tanstack/react-router';

import { ProjectsListPage } from '../features/projects/list/projects-page.js';
import {
  projectsSearchMiddlewares,
  projectsSearchSchema,
} from '../features/projects/list/projects-search.js';

export const Route = createFileRoute('/_authed/teams/$teamId/projects/')({
  validateSearch: projectsSearchSchema,
  search: { middlewares: projectsSearchMiddlewares },
  component: ProjectsListPage,
});
